export const MY_PROFILE = 'My Profile';
export const MY_COUPONS = 'My Coupons';
export const MY_WALLET = 'My Wallet';
export const MY_ORDERS = 'My Orders';
export const MY_WISHLIST = 'My Wishlist';
export const MY_SAVED_PAYMENTS = 'My Saved Payment';
export const LOGOUT = 'Log Out';
export const PROFILE_LINK = '/myProfile';
export const MY_COUPONS_LINK = '/myCoupons';
export const SAVED_PAYMENTS = 'savedPayments';
export const ORDERS_LINK = '/sales/order/history/v2';
export const WISHLIST_LINK = '/wishlist/';
export const WALLET_LINK = '/nykaaWallet/add';
export const MY_SAVED_PAYMENTS_LINK = '/mySavedPayment';
export const PROFILE_CLICK = 'profile_click';
export const LOGOUT_ERROR_MESSAGE = 'Error during logout';
export const ORDERS_REVAMP_LINK = '/my/orders';

export const MODAL_STYLE = {
  width: '300px',
  borderRadius: '4px',
};
